import { DEFAULT_CURRENCY_CODE } from '@klear/constants/currency'
import {
  FEE_COLLECTION_ALLOCATION_PAYMENT_TYPES,
  PAYMENT_STATUS_RETURNED,
  PAYMENT_TYPE_COLLECTION_PAAS,
  PAYMENT_TYPE_DISBURSEMENT_PAAS,
  type PaymentStatus,
  type PaymentType
} from '@klear/payment/constants'

export const PAAS_ADVANCE_PAYMENT_TYPES = [PAYMENT_TYPE_DISBURSEMENT_PAAS] as const satisfies readonly PaymentType[]

export const PAAS_REPAYMENT_PAYMENT_TYPES = [PAYMENT_TYPE_COLLECTION_PAAS] as const satisfies readonly PaymentType[]

export const PAAS_FEE_PAYMENT_TYPES = FEE_COLLECTION_ALLOCATION_PAYMENT_TYPES

export const PAAS_ALLOCATABLE_PAYMENT_TYPES = [
  ...PAAS_ADVANCE_PAYMENT_TYPES,
  ...PAAS_REPAYMENT_PAYMENT_TYPES,
  ...PAAS_FEE_PAYMENT_TYPES
] as const satisfies readonly PaymentType[]

export const PAAS_REVERSAL_PAYMENT_STATUSES = [PAYMENT_STATUS_RETURNED] as const satisfies readonly PaymentStatus[]

export const PAAS_STATUS_DRAFT = 'draft' as const
export const PAAS_STATUS_PENDING = 'pending' as const
export const PAAS_STATUS_OUTSTANDING = 'outstanding' as const
export const PAAS_STATUS_PARTIALLY_COLLECTED = 'partially_collected' as const
export const PAAS_STATUS_COLLECTED = 'collected' as const
export const PAAS_STATUS_VOIDED = 'voided' as const
export const PAAS_STATUS_RECONCILE = 'needs_reconciliation' as const

export const PAAS_STATUS_TYPES = [
  PAAS_STATUS_DRAFT,
  PAAS_STATUS_PENDING,
  PAAS_STATUS_OUTSTANDING,
  PAAS_STATUS_PARTIALLY_COLLECTED,
  PAAS_STATUS_COLLECTED,
  PAAS_STATUS_VOIDED,
  PAAS_STATUS_RECONCILE
] as const

export type PaasStatus = (typeof PAAS_STATUS_TYPES)[number]

export const PAAS_STATUS_LABELS = {
  [PAAS_STATUS_DRAFT]: 'Draft — to disburse',
  [PAAS_STATUS_PENDING]: 'Not settled',
  [PAAS_STATUS_OUTSTANDING]: 'Outstanding',
  [PAAS_STATUS_PARTIALLY_COLLECTED]: 'Partially repaid',
  [PAAS_STATUS_COLLECTED]: 'Repaid',
  [PAAS_STATUS_VOIDED]: 'Voided',
  [PAAS_STATUS_RECONCILE]: 'Needs reconciliation'
} as const satisfies Record<PaasStatus, string>

export const PAAS_SETTLEMENT_CURRENCY = DEFAULT_CURRENCY_CODE

export const PAAS_ALLOCATION_ROLES = ['advance', 'repayment', 'fee'] as const
